<div class="cliente-titulo-receber-view">
    <div class="container-header">
        <div class="container-header-block container-header-options">
            <!-- Opções -->
            <div class="btn-group" *ngIf="options?.hasAnyOption()">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-xl-inline-block">Opções</span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" *ngIf="options?.printListagem" (click)="printListagem()">
                        <i class="fas fa-print" aria-hidden="true"></i> Imprimir
                    </a>
                </div>
            </div>            
        </div>  

        <div class="container-header-block container-header-perspectiva-filter">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        Perspectiva
                    </span>
                </div>
                <div class="input-group-select">
                    <sgt-titulo-receber-perspectiva-select
                        [idPerspectiva]="filter.perspectiva"
                        (idPerspectivaChange)="onChangePerspectiva($event)"
                        [canSelectNull]="false">
                    </sgt-titulo-receber-perspectiva-select>
                </div>               
            </div>
        </div>
    </div>  

    <div class="container-filter">
        <sgt-titulo-receber-filter
            #tituloReceberFilter
            [initialization]="filterInitialization"
            [storageKey]="filterStorageKey"
            [filter]="filter"
            [isShowRepresentantesFilter]="false"
            [isShowClienteFilter]="false"
            [isShowClassificacoesClientesFilter]="false"
            (filterChange)="onFilterChange()"
            (filterCleaned)="onFilterCleaned()">
        </sgt-titulo-receber-filter>
    </div>    

    <div class="container-content">  
        <sgt-titulo-receber-table
            #table
            [filter]="filter"
            idDataTable="clienteTituloReceberTable"
            [visualizacaoStorageKey]="visualizacaoStorageKey"
            [optionsVisibility]="{
                canEdit: false,
                canVisualizar: true,
                canImportOneErp: false,
                canImportOneErp_v1: false
            }"
            (visualizarTitulo)="visualizarTitulo($event)">
        </sgt-titulo-receber-table>
    </div>    
</div>

 <!-- Form Modal -->
  <sgt-titulo-receber-form-modal
    #formModal>
  </sgt-titulo-receber-form-modal>